import React, { useState } from "react";
import {
  ChangePasswordContainer,
  ButtonContainer,
  Content,
  ShowPassword,
} from "./style";
import { BiCheckboxChecked, BiCheckbox } from "react-icons/bi";
import { Button } from "../../../../../reuseableComp.tsx/Button";
import SecurityIcon from "../../../../../useIconpark/security";
import { InputDiv } from "../../../../../reuseableComp.tsx/InputWithLogo";
import BackProfileButtonComp from "../BackProfileButtonComp";

interface ChangePasswordProps {
  closeChangePassword: () => void;
}

const ChangePassword = ({ closeChangePassword }: ChangePasswordProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleCheckboxChange = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <ChangePasswordContainer>
        <BackProfileButtonComp
          title="change password"
          closeFunction={closeChangePassword}
        />
        <Content>
          <div>
            <p>Current password</p>
            <InputDiv>
              <div>
                <SecurityIcon size={45} trigger="loop" delay={2000} />
              </div>
              <div>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="current Password"
                  required
                />
              </div>
            </InputDiv>
          </div>
          <div>
            <p>New password</p>
            <InputDiv>
              <div>
                <SecurityIcon size={45} trigger="loop" delay={2000} />
              </div>
              <div>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="new password"
                  required
                />
              </div>
            </InputDiv>
          </div>
          <div>
            <p>Confirm password</p>
            <InputDiv>
              <div>
                <SecurityIcon size={45} trigger="loop" delay={2000} />
              </div>
              <div>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="confirm password"
                  required
                />
              </div>
            </InputDiv>
          </div>
        </Content>
        <ShowPassword>
          <div onClick={handleCheckboxChange}>
            <span>
              {showPassword ? (
                <BiCheckboxChecked size="25" />
              ) : (
                <BiCheckbox size="25" />
              )}
            </span>
            <span>show password</span>
          </div>
        </ShowPassword>
        <ButtonContainer>
          <Button onClick={() => console.log("change password")}>
            Change password
          </Button>
        </ButtonContainer>
      </ChangePasswordContainer>
    </>
  );
};

export default ChangePassword;
